import { useState, useEffect } from 'react';
import { FaCalendarAlt, FaAlignLeft, FaTag, FaPlus, FaTimes, FaCheck } from 'react-icons/fa';
import useAuth from '../../hooks/useAuth';
import apiClient from '../../api/apiClient';

const TaskForm = ({ onAdd, onUpdate, taskToEdit, onCancel, categories }) => {
    const { user } = useAuth();
    const [text, setText] = useState('');
    const [description, setDescription] = useState('');
    const [category, setCategory] = useState('Other');
    const [dueDate, setDueDate] = useState('');

    useEffect(() => {
        if (taskToEdit) {
            setText(taskToEdit.text);
            setDescription(taskToEdit.description || '');

            // Handle legacy category mapping if needed
            let cat = taskToEdit.category || 'Autre';
            // Map legacy English tags to French equivalents for display match
            if (cat === 'Worship') cat = 'Adoration';
            if (cat === 'Work') cat = 'Travail';
            if (cat === 'Family') cat = 'Famille';
            if (cat === 'Other') cat = 'Autre';

            setCategory(cat);
            const dateStr = taskToEdit.dueDate ? new Date(taskToEdit.dueDate).toISOString().split('T')[0] : '';
            setDueDate(dateStr);
        } else {
            setText('');
            setDescription('');
            setCategory('Autre');
            setDueDate('');
        }
    }, [taskToEdit]);

    // Category logic removed (moved to parent)

    const onSubmit = (e) => {
        e.preventDefault();

        if (!text) {
            alert('Veuillez ajouter une tâche');
            return;
        }

        const taskData = { text, description, category, dueDate };

        if (taskToEdit) {
            onUpdate(taskToEdit._id, taskData);
        } else {
            onAdd(taskData);
        }

        if (!taskToEdit) {
            setText('');
            setDescription('');
            setCategory('Autre');
            setDueDate('');
        }
    };

    return (
        <form className="task-form" onSubmit={onSubmit}>
            <div className="input-group">
                <label className="input-label">Titre de la tâche</label>
                <input
                    type="text"
                    className="input-field"
                    placeholder="Ex: Lire Sourate Al-Kahf"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    autoFocus
                />
            </div>

            <div className="input-group">
                <label className="input-label"><FaAlignLeft /> Description</label>
                <textarea
                    className="input-field"
                    placeholder="Détails supplémentaires..."
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    rows="3"
                ></textarea>
            </div>

            <div className="input-group">
                <label className="input-label"><FaTag /> Catégorie</label>
                <div className="category-selector">
                    {categories && categories.map((cat) => (
                        <div
                            key={cat.id}
                            className={`category-badge ${category === cat.id ? 'selected' : ''}`}
                            style={{
                                backgroundColor: category === cat.id ? cat.color : cat.bg,
                                color: category === cat.id ? '#fff' : cat.color,
                                border: `1px solid ${cat.color}`
                            }}
                            onClick={() => setCategory(cat.id)}
                        >
                            {cat.label}
                        </div>
                    ))}
                </div>
            </div>

            <div className="input-group">
                <label className="input-label"><FaCalendarAlt /> Date d'échéance</label>
                <input
                    type="date"
                    className="input-field"
                    value={dueDate}
                    onChange={(e) => setDueDate(e.target.value)}
                />
            </div>

            <div className="form-actions" style={{ justifyContent: 'flex-end', marginTop: '30px' }}>
                {onCancel && (
                    <button type="button" className="btn btn-secondary" onClick={onCancel}>
                        Annuler
                    </button>
                )}
                <button type="submit" className="btn btn-primary">
                    {taskToEdit ? 'Mettre à jour' : 'Ajouter la tâche'}
                </button>
            </div>
        </form>
    );
};

export default TaskForm;

